import { inject, Pipe, PipeTransform } from '@angular/core';
import { InvoiceState } from '@common/enums';
import { I18NextPipe } from 'angular-i18next';
import { I18_NAMESPACE_APPS_UI } from 'i18n';
import lowerFirst from 'lodash/lowerFirst';

enum InvoiceStatusIcon {
  Error = 'fa fa-times-circle',
  Expose = 'fa fa-pause-circle',
  Paid = 'fa fa-check-circle',
  SendErrorEmail = 'fa fa-envelope-o',
  WaitPayment = 'fa fa-clock-o',
  WrongPrice = 'fa fa-exclamation-circle'
}

enum InvoiceStatusType {
  Error = 'danger',
  Expose = 'muted',
  Paid = 'success',
  SendErrorEmail = 'muted',
  WaitPayment = 'info',
  WrongPrice = 'danger'
}

@Pipe({
  name: 'invoiceStatus',
  pure: true
})
export class InvoiceStatusPipe implements PipeTransform {
  private readonly i18nPipe = inject(I18NextPipe);

  private readonly modulePayments = I18_NAMESPACE_APPS_UI.payments;

  private static readonly iconMap: Record<InvoiceState, string> = {
    [InvoiceState.Error]: InvoiceStatusIcon.Error,
    [InvoiceState.Expose]: InvoiceStatusIcon.Expose,
    [InvoiceState.Paid]: InvoiceStatusIcon.Paid,
    [InvoiceState.SendErrorEmail]: InvoiceStatusIcon.SendErrorEmail,
    [InvoiceState.WaitPayment]: InvoiceStatusIcon.WaitPayment,
    [InvoiceState.WrongPrice]: InvoiceStatusIcon.WrongPrice
  };

  private static readonly typeMap: Record<InvoiceState, string> = {
    [InvoiceState.Error]: InvoiceStatusType.Error,
    [InvoiceState.Expose]: InvoiceStatusType.Expose,
    [InvoiceState.Paid]: InvoiceStatusType.Paid,
    [InvoiceState.SendErrorEmail]: InvoiceStatusType.SendErrorEmail,
    [InvoiceState.WaitPayment]: InvoiceStatusType.WaitPayment,
    [InvoiceState.WrongPrice]: InvoiceStatusType.WrongPrice
  };

  transform(state: InvoiceState, param: 'icon' | 'type' | 'displayName' = 'icon'): any {
    if (!state) return '';

    switch (param) {
      case 'icon':
        return `${InvoiceStatusPipe.iconMap[state] || ''}`;
      case 'type':
        return InvoiceStatusPipe.typeMap[state] || '';
      case 'displayName':
        return (
          this.i18nPipe.transform(this.modulePayments + `:invoiceStatus.${lowerFirst(InvoiceState[state])}`, {
            format: 'capitalize'
          }) || 'Unknown'
        );
      default:
        throw new Error(`Caught error manually: Unknown param in InvoiceStatusPipe: ${param}`);
    }
  }
}
